import type { OrientationMode } from "../layouts/layoutTypes";

export interface OrientationSnapshot {
  mode: OrientationMode;
  source: "screen" | "media" | "size";
  width: number;
  height: number;
}

export function getCurrentOrientation(): OrientationMode {
  if (typeof window === "undefined") {
    return "landscape";
  }

  if (typeof window.matchMedia === "function" && window.matchMedia("(orientation: portrait)").matches) {
    return "portrait";
  }

  if (window.innerWidth !== window.innerHeight) {
    return window.innerHeight > window.innerWidth ? "portrait" : "landscape";
  }

  if (window.screen.orientation?.type) {
    return window.screen.orientation.type.includes("portrait") ? "portrait" : "landscape";
  }

  return window.innerHeight > window.innerWidth ? "portrait" : "landscape";
}

export function getOrientationSnapshot(): OrientationSnapshot {
  if (typeof window === "undefined") {
    return { mode: "landscape", source: "size", width: 1200, height: 800 };
  }

  const hasMedia = typeof window.matchMedia === "function" && window.matchMedia("(orientation: portrait)").matches;
  const hasScreen = Boolean(window.screen.orientation?.type);

  return {
    mode: getCurrentOrientation(),
    source: hasScreen ? "screen" : hasMedia ? "media" : "size",
    width: window.innerWidth,
    height: window.innerHeight
  };
}

export function getRecommendedOrientation(instrumentId: string): OrientationMode {
  const portraitFirst = new Set(["ney", "erhu", "yidaki_didgeridoo"]);

  return portraitFirst.has(instrumentId) ? "portrait" : "landscape";
}
